var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inited
    ? _c(
        "div",
        {
          staticClass: "preview_app",
          class: [
            "radius" + _vm.Global.mockupConfig.radiusRatio,
            _vm.Global.mockupConfig.activeFont,
            _vm.Global.mockupConfig.verticalNav ? "vert" : "",
          ],
        },
        [
          _c(
            "transition",
            { attrs: { name: "slideup" } },
            [
              _c("PreviewHeadbar", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$route.path !== "/player",
                    expression: "$route.path !== '/player'",
                  },
                ],
                attrs: {
                  scroll: _vm.offY,
                  logo: _vm.Global.mockupConfig.pictures.logo,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            {
              attrs: { name: "fade_preview" },
              on: { "after-enter": _vm.onAfterEnter, css: false },
            },
            [_c("router-view", { on: { scrollUpdate: _vm.scrollData } })],
            1
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "b-overlay",
            class: { active: _vm.Global.activePreviewOverlay },
          }),
          _vm._v(" "),
          _vm.Global.activePreviewInfoOverlay
            ? _c("PreviewInfoOverlay")
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "b-overlay z-mre",
            class: { active: _vm.Global.activeSubOverlay },
          }),
          _vm._v(" "),
          _vm.Global.activeSubInfoOverlay ? _c("SubOverlay") : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }